<template>
  <div class>
    <div class="bg-white my-2">
      <div class="text-center">
        <br />
        <b>MALL AVENTURA DIRECT</b>
        <br />( MAD)
      </div>

      <div class="text-justify mx-2">
        MALL AVENTURA DIRECT (MAD) (MAD) es un servicio implementado pensando en
        brindarle las facilidades de recoger sus compras adquiridas mediante una
        plataforma de comercio electrónico o Market Place asociada a MAD, en
        puntos de despacho especializados en función a la disponibilidad de
        tiempo del comprador.
      </div>
      <br />
      <div class="text-justify mx-2">
        Los módulos de despacho están localizados dentro de la cadena de Centros
        Comerciales Mall Aventura sede Arequipa-Paucarpata y sede Lima-Santa
        Anita, estratégicamente situados para garantizar la fácil accesibilidad
        de manera peatonal o vehicular.
      </div>
      <br />
      <div class="text-justify mx-2">
        El Servicio brindado por MALL AVENTURA DIRECT (MAD) es operado por
        Scharff Representaciones S.A., operador logístico especializado que
        garantizará la calidad de la atención sin contacto, en función a la
        disponibilidad de tiempo del cliente y en el menor tiempo posible
        respetando los protocolos de bioseguridad y distanciamiento, velando por
        la seguridad de los clientes.
      </div>
      <br />
      <br />
      <b>Acceso al Servicio</b>
      <br />
      <div class="text-justify mx-2">
        Culminada la compra mediante una plataforma de comercio electrónico o
        Market Place, el comprador deberá haber seleccionado la opción de recojo
        en los módulos de despacho de MALL AVENTURA DIRECT (MAD).
        <br />
      </div>
      <br />
      <div class="text-justify mx-2">
        El comprador recibirá un correo de (INDICAR LA DIRECCION DE CORREO)
        indicándole que su producto ya se encuentra en los módulos de MALL
        AVENTURA DIRECT (MAD), asegúrese de que llegue a su bandeja principal y
        no haya sido enviada a la bandeja de no deseados.
      </div>
      <br />
      <div class="mx-2 text-justify">
        Siguiendo el enlace recibido en el correo electrónico que recibirá el
        comprador deberá seguir los siguientes pasos:
      </div>
      <br />
      <div class="px-5  text-justify">
        1. Dentro de las 48 horas de recibido el correo deberá programar la
        modalidad de recojo de sus productos a pie o en auto, en el horario y
        fecha de acuerdo con su disponibilidad.
        <br />2. Una vez efectuada la programación deberá leer y aceptar las
        condiciones y términos del servicio de despacho.<br />
        3. Recibirá la programación registrada con el código único, la fecha y
        hora seleccionada y el número de estación de recojo.
        <br />4. En la modalidad previamente registrada en el sistema ( a pie o
        en auto), portando su código único de programación de recojo como
        constancia de la compra ( digital o impreso ), además de su documento de
        identidad original (DNI, Pasaporte o Carné de extranjería) , acérquese
        al Centro Comercial Mall Aventura (Santa Anita o Paucarpata) ,
        respetando el día y hora seleccionada por usted y cumpliendo las medidas
        de seguridad para preservar su salud y la del personal que gustosamente
        lo atenderá.<br />
        Si el retiro lo hará una tercera persona, completa el campo con su
        nombre cuando realices el proceso de compra y asegúrate que lleve
        Documento de Identidad original.
      </div>
      <br />
      <b>Si viene en auto:</b>
      <div class="text-justify mx-2">
        No será necesario que baje del auto, el personal le hará la entrega del
        producto al mismo respetando los protocolos de bioseguridad.
      </div>
      <br />
      <div class="text-justify mx-2">
        Contamos con un acceso vehicular debidamente identificado, destinado
        para que Ud. pueda llegar en su vehículo hasta el módulo de atención
        vehicular.
      </div>
      <br />
      <div>
        <b>Si viene a pie:</b>
      </div>
      <div class="text-justify mx-2">
        Deberá acceder peatonalmente al Centro Comercial Mall Aventura ubicar
        los módulos de atención MAD siguiendo la señalización de localización,
        acercarse a las ventanillas para su atención, el personal le hará la
        entrega del producto.
      </div>
      <div class="px-5 text-justify mx-2">
        5. Ubique la estación de despacho de MALL AVENTURA DIRECT (MAD) indicada
        en la confirmación de su programación.
        <br />6. Entregue su código único de programación de recojo (digital o
        impreso) e identifíquese en el módulo asignado.<br />
        7. Verifique que el empaque coincida con la identificación de su pedido,
        se encuentre sellado y en buenas condiciones externas.
        <br />8. El personal le tomará una foto del con el paquete como medio
        para comprobar la entrega de este al Market Place donde usted efectuó la
        compra o en su defecto una foto al documento de identidad del usuario
        junto al empaque. Siguiendo con las exigencias normativas de no utilizar
        documentos físicos, ni lapiceros compartidos que puedan poner su salud
        en riesgo<br />
        9. Retire sus compras.
        <br />(*) En caso de no estar conforme con su compra o tener algún
        inconveniente con la misma deberá seguir las indicaciones estipuladas en
        el numeral IV. 2 de los Términos y Condiciones más abajo descritos.
      </div>
      <br />
      <b>TERMINOS Y CONDICIONES DEL SERVICIO</b>
      <br />

      <div class="text-justify mx-2">
        Los siguientes términos y condiciones regulan el servicio al que
        accederá el cliente(s) titular de la compra al momento de elegir los
        puntos de atención de despacho de MALL AVENTURA DIRECT (MAD) para el
        recojo de los productos adquiridos a través del Market Place de su
        preferencia que este afiliado a MALL AVENTURA DIRECT (MAD) (MAD)
      </div>
      <br />
      <div class="text-justify mx-2">
        El comprador deberá leer las condiciones de uso descritas a continuación
        y declara tener conocimiento de estas previo a la aceptación del
        servicio, obligándose y obligando a quién autorice para el recojo al
        cumplimiento de estas.
      </div>
      <br />

      <b>I. CONDICIONES GENERALES</b>

      <div class="px-5 text-justify">
        1. MALL AVENTURA DIRECT (MAD) le garantiza la atención sin contacto.
        <br />2. En los puntos de despacho de MALL AVENTURA DIRECT (MAD) no se
        acepta el pago de los productos adquiridos.<br />
        3. Sólo se atenderá la entrega de pedidos en el horario programado.
        <br />
      </div>
      <br />
      <b>II. AL MOMENTO DE LA ENTREGA</b>
      <br />
      <div class="px-5 text-justify mx-2">
        1. Se atenderá sólo a una persona por ventanilla a la vez.
        <br />2. En caso de no recoger su pedido en el horario establecido
        deberá reprogramar el recojo dentro de las 48 de recibido el correo de
        parte de MALL AVENTURA DIRECT (MAD) siguiendo el link contenido en el
        mismo para la programación inicial.<br />
        El o los productos permanecerán en el punto de despacho 72 horas desde
        el envío del correo de confirmación de contar con el producto en los
        módulos de MAD para el recojo, cumplido dicho plazo, el producto se
        devolverá al Market Place y el comprador deberá comunicarse con el
        centro de atención del Market Place. (Ver descripción de los Términos y
        Condiciones - numeral IV inciso 2)
        <br />3. Para brindar el servicio MALL AVENTURA DIRECT (MAD) y el
        personal de atención cumplen estrictamente con todas las directivas y
        normas referidas a la prevención del contagio del COVID-19, por lo que
        no entregará el producto en caso de que el cliente no cumpla con las
        medidas de bioseguridad o de distanciamiento social recomendadas para
        evitar el contagio del COVID-19 descritas en el numeral V.
        <br />
      </div>
      <br />
      <b>III. ACERCA DE LOS PRODUCTOS:</b>
      <div class="px-5 text-justify mx-2">
        1. MALL AVENTURA DIRECT (MAD) es responsable únicamente de la entrega
        del paquete recibido por parte del Market Place al usuario (comprador o
        persona designada por el comprador). MAD no es responsable por el
        contenido del paquete o de los desperfectos que pudiese presentar el
        producto adquirido. <br />
        El almacenaje y el manejo de los paquetes se hace dependiendo del
        contenido de este y en función a las indicaciones del vendedor.
        <br />2. El personal de MALL AVENTURA DIRECT (MAD) está prohibido de
        abrir los empaques de los productos, ni a pedido del usuario.<br />
        3. El usuario de MAD deberá verificar externamente el empaque de los
        productos, validando que se encuentre sellado y en buenas condiciones
        externas para recibir el pedido.
        <br />En caso el usuario no esté conforme con la condición externa del
        paquete y esto sea causal de rechazo del pedido, MALL AVENTURA DIRECT
        (MAD) remitirá el producto al Market Place informando el motivo de
        rechazo por parte del usuario.<br />
        El comprador deberá comunicarse con el centro de atención del Market
        Place o plataforma de comercio online donde adquirió su producto. (Ver
        descripción de los Términos y Condiciones - numeral IV inciso 2).
        <br />4. MALL AVENTURA DIRECT (MAD) es un centro de despacho de
        productos, no tienen ninguna relación con el vendedor de los productos,
        por lo tanto, no recibirá ningún paquete o contenido de este en calidad
        de devolución. (Ver descripción de los Términos y Condiciones - numeral
        IV inciso 2)<br />
        5. En caso el estado de emergencia imponga nuevas medidas de aislamiento
        social que impidan cumplir con la entrega estando su producto en
        custodia de MALL AVENTURA DIRECT (MAD), nuestro personal se pondrá en
        contacto con el comprador para coordinar la entrega del producto en
        estricto cumplimiento de las normas que imponga el estado en ese
        momento. No es imputable a MALL AVENTURA DIRECT (MAD) la responsabilidad
        por el incumplimiento de la entrega en el horario inicial elegido de
        recojo, aceptando el cliente la posibilidad de reprogramaciones o
        aplazamientos, sin necesidad de acuerdo previo.
        <br />6. El manejo de la Información de cliente se regulará en función a
        todas las condiciones establecidas previamente en la plataforma de
        compra, respetando los derechos y obligaciones de los consumidores y los
        proveedores, que se regulan en la Ley N° 29733, el Decreto Supremo N°
        003-2013-JUS y las demás normas modificatorias y complementarias; los
        cuales resumimos en el siguiente enlace. ( link de acceso pedir a Betsy
        detalle)
      </div>
      <br />
      <b>IV. SERVICIO DE ATENCIÓN AL CLIENTE</b>

      <div class="px-5 text-justify">
        1. En caso de tener alguna duda o consulta adicional sírvase comunicar
        con el centro al cliente al correo (MAD@holascharff.com)
        <br />2. En caso de que tenga algún reclamo por el contenido de su
        empaque deberá comunicarse con el centro de atención del Market Place en
        el que adquirió el producto.<br />
        Si efectuó la compra en:
        <div class="ml-5 text-justify">
          i. Juntozz siga el siguiente enlace:
          <a href="https://juntoz.com/pages/changes ">
            https://juntoz.com/pages/changes
          </a>
          <br />ii. Lumingo siga el siguiente enlace:
          <a href="https://www.lumingo.com/politica-cambios">
            https://www.lumingo.com/politica-cambios
          </a>
          <br />
        </div>
        3. En caso de devolución del producto al Market Place de acuerdo con lo
        indicado en el numeral II.2, puede acceder a los siguientes enlaces para
        comunicarse con el Market Place.
        <div class="ml-5 text-justify">
          i. Juntozz comuníquese con el centro de atención al cliente a través
          de:
          <br />Teléfono: (01) 500-7899<br />
          Email: hola@juntoz.com
          <br />ii. Lumingo siga el siguiente enlace:
          <br />
          <a href="https://centraldeayuda.lumingo.com/hc/es-419">
            https://centraldeayuda.lumingo.com/hc/es-419
          </a>
          <br />
        </div>
      </div>

      <br />
      <b>V. PROTOCOLOS COVID</b>

      <div class="text-justify mx-2">
        En cumplimento con las normas y exigencias del estado peruano y con la
        finalidad de mantener informados a nuestros clientes, se hace de
        conocimiento del público los protocolos de recepción y almacenamiento de
        productos y de despacho productos de Scharff Representaciones S.A.
        <br />Link de acceso: _Pendiente de envío Scharff______
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
